var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71875 11.0235L16 10.0235V6.87505C16 6.54692 16.1602 6.30083 16.4805 6.05474C16.8008 5.97271 17.1211 5.97271 17.3594 6.13677C20.6406 8.43364 23.7617 12.2813 23.8398 12.4454C23.918 12.6016 23.9922 12.836 23.9961 13C23.9961 13.004 24 13.0118 24 13.0157C24 13.1797 23.9219 13.4258 23.8398 13.5079C23.7617 13.6719 20.7188 17.5313 17.3594 19.8282C17.0391 19.9922 16.7188 20.0743 16.4805 19.9102C16.1602 19.7461 16 19.5 16 19.1719V16.0235L2.71875 15.0235C2.32031 14.7032 2 13.8985 2 13.0157C2 12.2188 2.23828 11.3438 2.71875 11.0235Z",
    fill: "#7A69BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveArrow);
export default __webpack_public_path__ + "static/media/move-arrow.2224fee62839844616bae33335551923.svg";
export { ForwardRef as ReactComponent };